/**
 * Finds the common words among the given array of phrases.
 *
 * @param {string[]} splittedPhrases - The array of phrases to find common words from.
 * @returns {string[]} - The array of common words found.
 */
export const findCommonWords = (splittedPhrases) => {
  const aggregator = [];
  let i = 0;
  while (
    !splittedPhrases.filter((splittedPhrase) => !splittedPhrase[i]).length &&
    !splittedPhrases.filter((splittedPhrase) => splittedPhrase[i] !== splittedPhrases[0][i]).length
  ) {
    aggregator.push(splittedPhrases[0][i]);
    i++;
  }

  return aggregator;
};

/**
 * Removes a chunk from a phrase.
 *
 * @param {string} phrase - The original phrase.
 * @param {string[]} chunk - The chunk to be removed.
 * @param {string} [position='front'] - The position of the chunk in the phrase. Can be 'front' or 'back'.
 * @returns {string} - The modified phrase with the chunk removed.
 */
export const removeChunkFromPhrase = (phrase, chunk, position = 'front') => {
  const theregex = position !== 'front' ? new RegExp(`${chunk.join(' ')}$`) : new RegExp(`^${chunk.join(' ')}`);

  return phrase.replace(theregex, '');
};

/**
 * Trims both sides of each phrase in the given array.
 *
 * @param {string[]} phrases - The array of phrases to trim.
 * @returns {string[]} - The array of trimmed phrases.
 */
export const trimBothSides = (phrases) => {
  if (!Array.isArray(phrases) || phrases.length < 2) {
    return [];
  }
  const splittedPhrases = phrases.map((phrase) => phrase.split(' '));

  const frontTrimmer = findCommonWords(splittedPhrases);
  const backTrimmer = findCommonWords(splittedPhrases.map((phrase) => phrase.reverse())).reverse();

  return phrases.map((phrase) =>
    removeChunkFromPhrase(removeChunkFromPhrase(phrase, frontTrimmer, 'front'), backTrimmer, 'back').trim()
  );
};
